import { Component, Input, OnInit } from '@angular/core';
import { Brand, BrandService } from '../../core/brand';
import { CONSTANTS } from '../constants/constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() public brand: Brand;
  @Input() public isCombinedApplication: boolean;
  public readonly constants = CONSTANTS;
  public showHelpSection: boolean = false;

  constructor(public brandService: BrandService) {}

  public ngOnInit(): void {
    this.brandService.brand.subscribe((brand) => {
      this.showHelpSection = brand !== CONSTANTS.PAYSAFECARD.brandName;
    });
  }
}
